import { CheckBox } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';
import { PERMISSION_LABELS } from '../cells/PermissionsCell.helpers';
import { TPermissions } from '../cells/PermissionsCell.types';
import styles from './UserPermissionsFields.module.css';

type TProps = {
  isSelf?: boolean;
};

export const UserPermissionsFields = ({ isSelf = false }: TProps) => {
  const { register } = useFormContext<{ permissions: TPermissions }>();

  return (
    <fieldset className={styles.permissions}>
      <legend className={styles.permissionsLegend}>Account permissions</legend>
      <div className={styles.permissionsGrid}>
        {PERMISSION_LABELS.map((permission) => {
          const isManageUsers = permission.key === 'can_manage_account_users';
          return (
            <CheckBox
              key={permission.key}
              label={permission.label}
              disabled={isSelf && isManageUsers}
              {...register(`permissions.${permission.key}`)}
            />
          );
        })}
      </div>
    </fieldset>
  );
};
